import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import './selectable.scss';

const styles = bemGenerator('pj-ui-search-selectable');

const Selectable = props => {
  const isSelected = String(props.selected) === String(props.id);

  return (
    <div
      className={styles.block.withModifier({
        selected: isSelected,
      })}
      role="option"
      aria-selected={isSelected}
      data-selected={isSelected}
      data-query={props.query}
      data-selection-id={props.id}
      id={`selection${props.id}`}
    >
      {props.children}
    </div>
  );
};

Selectable.propTypes = {
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  query: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Selectable.defaultProps = {
  selected: undefined,
  query: undefined,
};

export default Selectable;
